import {
  Stack,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  List,
  ListItemIcon,
} from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import { formatCurrency } from "../../../utils/formatCurrency";
import carCrash from "../../../Assets/CrashCar.svg";
import crane from "../../../Assets/crane.svg";
import carTheft from "../../../Assets/CarRobbery.svg";
import personalAccident from "../../../Assets/PersonalAccident.svg";
import cellphoneTheft from "../../../Assets/SmartphoneRobbery.svg";
import screenBreak from "../../../Assets/screen-breakage.svg";
import breakdown from "../../../Assets/breakdown.svg";
import accidentalDemage from "../../../Assets/accidental-damage.svg";
import tire from "../../../Assets/Tire.svg";
import keyslock from "../../../Assets/Keys.svg";
import battery from "../../../Assets/Battery.svg";
import gasoline from "../../../Assets/Oil.svg";
import { format } from "date-fns";

const ClaimBenefitsStep = ({ state, setState }) => {
  const calculateTotalSaved = () => {
    return state?.claims?.reduce(
      (total, claim) => total + claim.totalAmount,
      0
    );
  };
  const calculateTotalPayed = () => {
    return state?.claims?.reduce((total, claim) => total + claim.deductible, 0);
  };

  const totalSaved = formatCurrency(calculateTotalSaved());
  const totalPayed = formatCurrency(calculateTotalPayed());

  const formatDate = (timestamp) => {
    return format(new Date(timestamp), "dd/MM/yyyy");
  };

  function ListItemClaims({ i, claim }) {
    const imageIcon = {
      tire: tire,
      locksmith: keyslock,
      battery: battery,
      gasoline: gasoline,
      tow: crane,
      vehicleAccident: carCrash,
      carTheft: carTheft,
      personalAccident: personalAccident,
      cellphoneTheft: cellphoneTheft,
      "screen-breakage": screenBreak,
      breakdown: breakdown,
      "accidental-damage": accidentalDemage,
    };

    return (
      <>
        <ListItem alignItems="center" sx={{ padding: "10px 0px" }}>
          <ListItemAvatar>
            <Avatar
              alt={claim.title}
              sx={{
                width: "50px",
                height: "50px",
              }}
              src={
                imageIcon[
                  claim.isAVialAssistance ? claim.assistanceType : claim.type
                ]
              }
            />
          </ListItemAvatar>
          <ListItemText
            sx={{ marginLeft: "5px" }}
            primary={
              <Typography
                sx={{ display: "inline", fontWeight: 600 }}
                component="span"
                variant="body1"
              >
                {claim.title}
              </Typography>
            }
            secondary={
              <>
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {`Fecha: ${formatDate(claim.accidentTimestamp)}`}
                </Typography>
              </>
            }
          />
          <ListItemIcon sx={{ flexDirection: "column", textAlign: "right" }}>
            <Typography
              variant="body2"
              sx={{ fontSize: "1rem", fontWeight: 500 }}
            >
              Clupp pagó
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 700,
                fontSize: "1.1rem",
                color: "#d32f2f",
                marginTop: "-5px",
              }}
            >
              {formatCurrency(claim.totalAmount)}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "1rem", fontWeight: 500, mt: 1 }}
            >
              Tú pagaste
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 700,
                fontSize: "1.1rem",
                color: "#00796b",
                marginTop: "-5px",
              }}
            >
              {formatCurrency(claim.deductible)}
            </Typography>
          </ListItemIcon>
        </ListItem>
        <Divider variant="inset" component="li" />
      </>
    );
  }

  return (
    <>
      <TitleHeaders
        title={
          "¿Estás listo para que veamos cuanto has ahorrado en tus siniestros por estar con Clupp?"
        }
        subtitle={"Revisemos juntos los beneficios y ahorros que has obtenido."}
      />
      {state && Boolean(state?.claims?.length > 0)
        ? state.claims.map((claim, i) => (
            <List
              sx={{ width: "100%", bgcolor: "background.paper", p: 0 }}
              key={claim.id}
            >
              <ListItemClaims claim={claim} i={i} />
            </List>
          ))
        : null}
      <Box
        sx={{
          mt: 3,
          mx: "auto",
          width: "90%",
          p: 1,
          borderRadius: "8px",
          backgroundColor: "#E3F2FD",
          textAlign: "center",
        }}
      >
        <Typography variant="h5">
          {"¡Wow! Tu cartera te agradece que tengas cobertura."}
          <br />
          {calculateTotalPayed() === 0
            ? "No pagaste nada."
            : `Tu solo pagaste: ${totalPayed}`}
          <br />Y ahorraste{" "}
          <Typography component="span" variant="h5" sx={{ fontWeight: 700 }}>
            {totalSaved}
          </Typography>
        </Typography>
        <Typography variant="h6" sx={{ mt: 2 }}>
          {"¿Estás seguro de querer cancelar?"}
        </Typography>
      </Box>
    </>
  );
};

export default ClaimBenefitsStep;
